// load ReactJS front controller
require('./index.antd.js')
